/* eslint-disable @typescript-eslint/no-explicit-any */
import { Fragment, useMemo, useRef, useState } from "react";
import { SortableContext, useSortable } from "@dnd-kit/sortable";
import TaskCard from "./TaskCard";
import { Button, Dropdown, Popover } from "antd";
import { CloseCircleOutlined, MoreOutlined } from "@ant-design/icons";
import RouteIcon from "../../../../atoms/CustomIcons/RouteIcon";
import ConfirmIcon from "../../../../atoms/CustomIcons/ConfirmIcon";
import RescheduleIcon from "../../../../atoms/CustomIcons/RescheduleIcon";
import UnscheduleIcon from "../../../../atoms/CustomIcons/UnscheduleIcon";
import TimeSheetIcon from "../../../../atoms/CustomIcons/TimeSheetIcon";
import FlagIcon from "../../../../atoms/CustomIcons/FlagIcon";
import { PopUp } from "../../../../atoms/PopUp";
import ConfirmDelete from "../../../../atoms/ConfirmDelete";
import SuccessMessage from "../../../../atoms/Toasts/SuccessMessage";
import RescheduleVisits from "../RescheduleVisits";
import dayjs from "dayjs";
import MakeDayOff from "../MakeDayOff";
import EditStartFinishPoint from "../EditStartFinishPoint";
import MoveCrewScheduleBy from "../MoveCrewScheduleBy";
import ChangeShiftYardTime from "../ChangeShiftYardTime";
import RouteCalculate from "../../../../atoms/CustomIcons/RouteCalculate";
import MoveIcon from "../../../../atoms/CustomIcons/MoveIcon";
import ChangeShift from "../../../../atoms/CustomIcons/ChangeShift";
import HomeIcon from "../../../../atoms/CustomIcons/HomeIcon";
import DayOffIcon from "../../../../atoms/CustomIcons/DayOffIcon";
import { formatCrewLeaderName } from "../../../../config/utils";
import { SelectArrow } from "../../../../atoms/CustomIcons";
import HourCard from "./HourCard";
import CrewCard from "./CrewCard";

function ColumnContainer(props: any) {
  const {
    column,
    tasks,
    setScheduleId,
    setShowScheduled,
    crewDrop,
    setColumns,
    allColumns,
    selectedDate,
    isDragging,
    index,
  } = props;

  const tasksId = useMemo(
    () => tasks?.map((task: { id: number }) => task?.id),
    [tasks]
  );

  const { setNodeRef } = useSortable({
    id: column.id,
    data: {
      type: "Column",
      column,
    },
  });
  const dropdownRef = useRef<HTMLButtonElement>(null);

  const items = [
    {
      key: "1",
      label: (
        <Button
          type="text"
          className="no-hover"
          onClick={(e) => {
            e.stopPropagation();
            if (dropdownRef.current) {
              dropdownRef?.current?.click();
            }
          }}
        >
          <RouteIcon /> Show route on a map
        </Button>
      ),
    },
    {
      key: "2",
      label: (
        <Button
          type="text"
          className="no-hover"
          onClick={(e) => {
            e.stopPropagation();
            if (dropdownRef.current) {
              dropdownRef?.current?.click();
            }
            setConfirmAllWO(true);
          }}
        >
          <ConfirmIcon /> Confirm all work orders
        </Button>
      ),
    },
    {
      key: "3",
      label: (
        <Button
          type="text"
          className="no-hover"
          onClick={(e) => {
            e.stopPropagation();
            if (dropdownRef.current) {
              dropdownRef?.current?.click();
            }
            setRescheduleVisitModal(true);
          }}
        >
          <RescheduleIcon /> Reschedule remaining visits
        </Button>
      ),
    },
    {
      key: "4",
      label: (
        <Button
          type="text"
          className="no-hover"
          onClick={(e) => {
            e.stopPropagation();
            if (dropdownRef.current) {
              dropdownRef?.current?.click();
            }
          }}
        >
          <UnscheduleIcon /> Unschedule all remaining visits
        </Button>
      ),
    },
    {
      key: "5",
      label: (
        <Button
          type="text"
          className="no-hover"
          onClick={(e) => {
            e.stopPropagation();
            if (dropdownRef.current) {
              dropdownRef?.current?.click();
            }
          }}
        >
          <TimeSheetIcon /> Open timesheet
        </Button>
      ),
    },
    {
      key: "6",
      label: (
        <Button
          type="text"
          className="no-hover"
          onClick={(e) => {
            e.stopPropagation();
            if (dropdownRef.current) {
              dropdownRef?.current?.click();
            }
          }}
        >
          <FlagIcon /> Edit finish point
        </Button>
      ),
    },
  ];
  const itemsFuture = [
    {
      key: "1",
      label: (
        <Button
          type="text"
          className="no-hover"
          onClick={(e) => {
            e.stopPropagation();
            // if (dropdownRef.current) {
            //   dropdownRef?.current?.click();
            // }
          }}
        >
          <RouteCalculate /> Calculate route
        </Button>
      ),
    },
    {
      key: "2",
      label: (
        <Button
          type="text"
          className="no-hover"
          onClick={(e) => {
            e.stopPropagation();
            // if (dropdownRef.current) {
            //   dropdownRef?.current?.click();
            // }
          }}
        >
          <CloseCircleOutlined /> Discard unpublished changes
        </Button>
      ),
    },
    {
      key: "3",
      label: (
        <Button
          type="text"
          className="no-hover"
          onClick={(e) => {
            e.stopPropagation();
            if (dropdownRef.current) {
              dropdownRef?.current?.click();
            }
            setRescheduleVisitModal(true);
          }}
        >
          <MoveIcon /> Reschedule the whole day
        </Button>
      ),
    },
    {
      key: "4",
      label: (
        <Popover
          arrow={false}
          content={
            <>
              <Button type="text" className="no-hover">
                1 day forward
              </Button>
              <Button type="text" className="no-hover">
                2 days forward
              </Button>
              <Button
                type="text"
                className="no-hover"
                onClick={(e) => {
                  e.stopPropagation();
                  if (dropdownRef.current) {
                    dropdownRef?.current?.click();
                  }
                  setMoveCrewScheduleByModal(true);
                }}
              >
                Custom period ...
              </Button>
            </>
          }
          // trigger="click"
          placement="rightTop"
          getPopupContainer={(trigger) =>
            trigger.parentElement || document.body
          }
        >
          <Button type="text" className="no-hover">
            <RescheduleIcon /> Move crew’s schedule by ...
          </Button>
        </Popover>
      ),
    },
    {
      key: "5",
      label: (
        <Button
          type="text"
          className="no-hover"
          onClick={(e) => {
            e.stopPropagation();
            if (dropdownRef.current) {
              dropdownRef?.current?.click();
            }
            setChangeShiftYardTimeModal(true);
          }}
        >
          <ChangeShift /> Change shift & yard time
        </Button>
      ),
    },
    {
      key: "6",
      label: (
        <Button
          type="text"
          className="no-hover"
          onClick={(e) => {
            e.stopPropagation();
            if (dropdownRef.current) {
              dropdownRef?.current?.click();
            }
            setEditStartPointModal(true);
          }}
        >
          <HomeIcon /> Edit start point
        </Button>
      ),
    },
    {
      key: "7",
      label: (
        <Button
          type="text"
          className="no-hover"
          onClick={(e) => {
            e.stopPropagation();
            if (dropdownRef.current) {
              dropdownRef?.current?.click();
            }
            setEditFinishPointModal(true);
          }}
        >
          <FlagIcon /> Edit finish point
        </Button>
      ),
    },
    {
      key: "8",
      label: (
        <Button
          type="text"
          className="no-hover"
          onClick={(e) => {
            e.stopPropagation();
            if (dropdownRef.current) {
              dropdownRef?.current?.click();
            }
            setMakeDayOffModal(true);
          }}
        >
          <DayOffIcon /> Make a day-off
        </Button>
      ),
    },
  ];

  const [confirmAllWO, setConfirmAllWO] = useState(false);
  const [rescheduleVisitModal, setRescheduleVisitModal] = useState(false);
  const [editStartPointModal, setEditStartPointModal] = useState(false);
  const [editFinishPointModal, setEditFinishPointModal] = useState(false);

  const [changeShiftYardTimeModal, setChangeShiftYardTimeModal] =
    useState(false);
  const [moveCrewScheduleByModal, setMoveCrewScheduleByModal] = useState(false);
  const [makeDayOffModal, setMakeDayOffModal] = useState(false);

  // const totalHoursForColumn =
  //   column?.visit?.reduce((sum: any, visit: any) => {
  //     const start = dayjs(visit.start);
  //     const end = dayjs(visit.end);
  //     // Calculate duration in hours (as a float)
  //     const visitDurationHours = end.diff(start, "hour", true);
  //     return sum + visitDurationHours;
  //   }, 0) || 0; // Default to 0 if no visits or calculation fails

  // // Calculate the maximum possible hours for the crew in this column
  // // This is based on your existing logic: crewMembers.length * 8
  // const maxCrewHours = (column?.crewMembers?.length || 0) * 8;

  // // Calculate the percentage for the progress bar
  // // Handle division by zero if maxCrewHours is 0
  // const progressBarPercent =
  //   maxCrewHours > 0 ? (totalHoursForColumn / maxCrewHours) * 100 : 0;

  const btnConfirmAllWorkOrders = async () => {
    SuccessMessage("Work orders confirmed");
    setConfirmAllWO(false);
  };

  const btnRescheduleVisits = async () => {
    SuccessMessage("Visits rescheduled");
    setRescheduleVisitModal(false);
  };
  const btnChangeShiftYardTime = async () => {
    SuccessMessage("Shift start time changed");
    setChangeShiftYardTimeModal(false);
  };
  const btnMoveCrewScheduleBy = async () => {
    SuccessMessage("Crew schedule moved");
    setMoveCrewScheduleByModal(false);
  };
  const btnEditStartPoint = async () => {
    SuccessMessage("Start point changed");
    setEditStartPointModal(false);
  };
  const btnEditFinishPoint = async () => {
    SuccessMessage("Finish point changed");
    setEditFinishPointModal(false);
  };
  const btnMakeDayOff = async () => {
    SuccessMessage("Day off scheduled");
    setMakeDayOffModal(false);
  };

  const confirmAllWorkOrders = {
    visibility: confirmAllWO,
    content: (
      <ConfirmDelete
        title=""
        onClose={() => setConfirmAllWO(false)}
        heading="Confirm all work orders for this route"
        paragraph={
          <Fragment>
            This will mark all work orders completed by the crew as confirmed.
            <br />
            <br />
            Are you sure you want to proceed?
          </Fragment>
        }
        btnText="Confirm"
        loading={false}
        isArchivePopup
        btnApi={btnConfirmAllWorkOrders}
      />
    ),
    width: 480,
    onCancel: () => setConfirmAllWO(false),
  };

  const rescheduleVisit = {
    visibility: rescheduleVisitModal,
    content: (
      <RescheduleVisits
        onClose={() => setRescheduleVisitModal(false)}
        btnApi={btnRescheduleVisits}
        loading={false}
      />
    ),
    width: 360,
    onCancel: () => setRescheduleVisitModal(false),
  };
  const changeShiftYardTime = {
    visibility: changeShiftYardTimeModal,
    content: (
      <ChangeShiftYardTime
        onClose={() => setChangeShiftYardTimeModal(false)}
        btnApi={btnChangeShiftYardTime}
        loading={false}
      />
    ),
    width: 385,
    onCancel: () => setChangeShiftYardTimeModal(false),
  };
  const moveCrewScheduleBy = {
    visibility: moveCrewScheduleByModal,
    content: (
      <MoveCrewScheduleBy
        onClose={() => setMoveCrewScheduleByModal(false)}
        btnApi={btnMoveCrewScheduleBy}
        loading={false}
        selectedDate={selectedDate}
      />
    ),
    width: 480,
    onCancel: () => setMoveCrewScheduleByModal(false),
  };
  const editStartPoint = {
    visibility: editStartPointModal,
    content: (
      <EditStartFinishPoint
        onClose={() => setEditStartPointModal(false)}
        btnApi={btnEditStartPoint}
        loading={false}
        title="Edit start point"
        paragraph="By default, the crew starts their day at their assigned yard. When needed, you can change it to a different location."
      />
    ),
    width: 480,
    onCancel: () => setEditStartPointModal(false),
  };
  const editFinishPoint = {
    visibility: editFinishPointModal,
    content: (
      <EditStartFinishPoint
        onClose={() => setEditFinishPointModal(false)}
        btnApi={btnEditFinishPoint}
        loading={false}
        title="Edit finish point"
        paragraph="By default, the crew finishes their day at their assigned yard. When needed, you can change it to a different location."
      />
    ),
    width: 480,
    onCancel: () => setEditFinishPointModal(false),
  };
  const makeDayOff = {
    visibility: makeDayOffModal,
    content: (
      <MakeDayOff
        onClose={() => setMakeDayOffModal(false)}
        btnApi={btnMakeDayOff}
        loading={false}
        selectedDate={selectedDate}
      />
    ),
    width: 480,
    onCancel: () => setMakeDayOffModal(false),
  };

  const today = dayjs();
  const comparisonDate = dayjs(selectedDate);

  console.log("tasks", tasks);

  // const totalScheduledMinutes =
  //   tasks?.reduce(
  //     (sum: number, task: any) =>
  //       sum + (task?.durationMinutes + +task?.drive_time || 0),
  //     0
  //   ) || 0;
  const totalScheduledHours = 32;

  return (
    <div className="column_wrapper" ref={setNodeRef}>
      <div className="column_header">
        <div className="column_title">
          <span>{column?.name}</span>{" "}
          {formatCrewLeaderName(column?.crew_leader)}
        </div>
        <div className="column_actions">
          <Dropdown
            menu={{
              items: comparisonDate.isAfter(today, "day") ? itemsFuture : items,
            }}
            trigger={["click"]}
            placement="bottomLeft"
            className="actionButton"
          >
            <Button
              onClick={(e) => {
                e.stopPropagation();
              }}
              onKeyDown={(e) => e.stopPropagation()}
              className="white_border"
              icon={<MoreOutlined />}
              ref={dropdownRef}
            />
          </Dropdown>
        </div>
      </div>
      <div className="columns_info">
        <HourCard
          column={column}
          totalScheduledHours={totalScheduledHours || 0}
        />
        <CrewCard
          column={column}
          crewDrop={crewDrop}
          setColumns={setColumns}
          allColumns={allColumns}
          selectedDate={selectedDate}
          index={index}
        />
      </div>

      <div className="column_content">
        <SortableContext items={tasksId}>
          {tasks?.length > 0 ? (
            tasks?.map((task: any, i: number) => (
              <TaskCard
                key={task.id}
                task={task}
                index={i}
                totalLength={tasks?.length}
                selectedDate={selectedDate}
                // dateInFuture={
                //   task?.start
                //     ? dayjs(task?.start)?.isAfter(dayjs(), "minutes")
                //     : false
                // }
              />
            ))
          ) : (
            <div className="no_task" style={{ textAlign: "center" }}>
              No visits <br />
              <br />
              There were no visits scheduled
            </div>
          )}
        </SortableContext>
        {!isDragging && (
          <Button
            onClick={() => {
              setScheduleId(column.id);
              setShowScheduled(true);
            }}
            className="view_schedule_button"
            icon={<SelectArrow />}
          >
            View schedule
          </Button>
        )}
      </div>

      <PopUp {...confirmAllWorkOrders} />
      <PopUp {...rescheduleVisit} />
      <PopUp {...changeShiftYardTime} />
      <PopUp {...moveCrewScheduleBy} />
      <PopUp {...editStartPoint} />
      <PopUp {...editFinishPoint} />
      <PopUp {...makeDayOff} />
    </div>
  );
}

export default ColumnContainer;
